import { render, staticRenderFns } from "./ClientForm.vue?vue&type=template&id=5b864994&scoped=true"
import script from "./ClientForm.vue?vue&type=script&lang=js"
export * from "./ClientForm.vue?vue&type=script&lang=js"
import style0 from "./ClientForm.vue?vue&type=style&index=0&id=5b864994&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b864994",
  null
  
)

export default component.exports